import React from 'react';
import {
    Stack,
    Box,
    TextField,
    Button,
    Grid,
    Checkbox,
    InputLabel,
    Select,
    MenuItem,
    Typography,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import { SubscriptionTierList } from './BundleService';
import { checkboxClasses } from '@mui/material/Checkbox';
import { useTheme } from '@emotion/react';
export default function CardDetailsView({ card, onSaveCard, onClose, onBackClicked }) {
    const { control, handleSubmit } = useForm({
        defaultValues: { ...card },
    });
    const theme = useTheme();
    const contentList = card.cardData?.contentList;
    const [cardVariation, setCardVariation] = React.useState(card.variation || '');
    const [cardVariationData, setCardVariationData] = React.useState('');

    React.useEffect(() => {
        if(cardVariation) {
            const variation = cardVariation.split('/');
            const matchedVariation = contentList?.find(e => e.locations===variation[0] && e.participants===variation[1]);
            setCardVariationData(matchedVariation);
            setCardVariation(matchedVariation?.locations+"/"+matchedVariation?.participants);
        }
    }, [cardVariation,contentList]);

    function getNotes(cv) {
        const variation = cv.split('/');
        const matchedVariation = contentList?.find(e => e.locations===variation[0] && e.participants===variation[1]);
        setCardVariationData(matchedVariation);
        setCardVariation(matchedVariation?.locations+"/"+matchedVariation?.participants);
    }

    async function onFromError(errors) {
        alert('Form data validation error.  Check console for details.');
        console.log('Form validation error ', errors);
    }

    // const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
    //     control: control,
    //     name: 'subscriptionMap',
    // });

    function backClicked() {
        onBackClicked();
    }
    function saveClicked() {
        handleSubmit(onSaveCard, onFromError)()
            .catch((err) => {
                console.error('Save data error', err);
                alert('Save data error.  Check console for details.');
                throw err;
            })
            .then(() => {
                onClose();
            });
    }

    return (
        <Stack direction="column" sx={{ justifyContent: 'space-between', flex: 1 }}>
            <Stack direction="column" sx={{  flex: 1 }}>
                <Grid item xs={12}>
                    <Typography style={{ flex: '1', whiteSpace: 'no-wrap', fontSize: '20px' }}>
                        {card.cardName}
                    </Typography>                       
                </Grid>
                <Grid container spacing={10} sx={{ paddingTop: '20px' }}>
                    <Grid container direction="row" justify="flex-start" alignItems="center" minHeight={300} spacing={1} item xs={6}>
                        <Grid item xs={2}>
                            <InputLabel id="cardImage.thumbn-label">Thumbnail</InputLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <Controller
                                control={control}
                                name="cardImage.thumbnailUrl"
                                render={({ field }) => (
                                    <Stack direction="row" spacing={10}>                                        
                                        <Box
                                            sx={{
                                                height: 50,
                                                width: 50,
                                                p: 1,
                                                border: '0px',
                                                m: 1,
                                                alignItems: 'center',
                                                justifyItems: 'center',
                                            }}
                                        >
                                            <img alt="" src={field.value} style={{ height: 46, width: 46 }} />
                                        </Box>
                                        <TextField id="cardImage" variant="outlined" fullWidth {...field} />
                                    </Stack>
                                )}
                            />
                        </Grid>
                        {card.cardType==='MICROEXPERIENCE' && <>
                        <Grid item xs={2}>
                            <InputLabel id="cardName-variantion">Variation</InputLabel>
                        </Grid>
                        <Grid item xs={9}>
                            <Controller
                                name="variation"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <Select {...field} fullWidth id="cardName-variantionType" labelId="cardName-variantion" {...field} 
                                    value={cardVariation}
                                    onChange={(e) => {
                                        field.onChange(e.target.value);
                                        getNotes(e.target.value);
                                    }}
                                    >
                                        {contentList.map((c) => (
                                            <MenuItem value={c?.locations+'/'+c?.participants}>{c?.locations+'/'+c?.participants}</MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </Grid>
                        </>
                        }
                        {SubscriptionTierList.map((sub, index) => (
                        <Grid key={sub.code} container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                            <Grid item xs={2}>
                                <InputLabel id={`cardSubscription${sub.code}-label`}>{sub.label}</InputLabel>
                            </Grid>
                            <Grid item xs={9}>
                                <Stack direction="row" spacing={12} justify="flex-start">
                                    <Controller
                                        control={control}
                                        defaultValue={sub.defaultValue}
                                        name={`subscriptionMap[${index}].isAvailable`}
                                        render={({ field, ref }) => (
                                            <Checkbox
                                                {...field}
                                                checked={field.value}
                                                sx={{
                                                    [`&.${checkboxClasses.checked}`]: {
                                                        color: theme.palette.amazingco.pink,
                                                    },
                                                    [`&`]: { color: 'blue' },
                                                }}
                                            />
                                        )}
                                    />
                                    {card.cardType==='PRODUCT' && <>
                                    <InputLabel>Discount</InputLabel>
                                    <Controller
                                        control={control}
                                        defaultValue={0}
                                        name={`subscriptionMap[${index}].discount`}
                                        render={({ field, ref }) => (
                                            <TextField size="small" style={{ width: 120 }} {...field} />
                                        )}
                                    />
                                    <span>%</span>
                                    </>
                                    }
                                </Stack>
                            </Grid>
                        </Grid>
                        ))}
                    </Grid>
                    <Grid  direction="column" container justify="flex-start" alignItems="left" item xs={6}>
                    {card.cardType==='MICROEXPERIENCE' && 
                    <>
                        <InputLabel id='variationNote'>MX Description</InputLabel>                    
                        <Box 
                            display="flex"
                            style={{ border: '1px solid #ccc', borderRadius: '4px', height: '150px', width: '450px',  padding: '10px', 
                            overflow: "hidden",
                            overflowY: "scroll", }}
                        >
                            <Typography style={{ flex: '1', whiteSpace: 'no-wrap', fontSize: '14px' }}>
                                {card.cardData?.description}
                            </Typography>
                        </Box>                        
                        <InputLabel id='variationNote'>Variaton Notes</InputLabel>                    
                        <Box 
                            display="flex"
                            style={{ border: '1px solid #ccc', borderRadius: '4px', height: '150px', width: '450px',  padding: '10px',
                            overflow: "hidden",
                            overflowY: "scroll", }}
                        >
                            <Typography style={{ flex: '1', whiteSpace: 'no-wrap', fontSize: '14px' }}>
                                {cardVariationData?.notes}
                            </Typography>
                        </Box>                       
                    </>
                    }
                    </Grid>
                </Grid>                
            </Stack>
            <Stack direction="row" justifyContent="flex-end" spacing={8} m={4} justifySelf="flex-end">
                {!!onBackClicked && (
                    <Button variant="contained" color="secondary" onClick={backClicked}>
                        Back to list
                    </Button>
                )}
                <Button variant="contained" color="primary" onClick={saveClicked} disabled={card.cardType==='MICROEXPERIENCE' && !cardVariation}>
                    Save Card
                </Button>
            </Stack>
            {/* <pre style={{ width : '600px', height : 200}}>{JSON.stringify(card, null, 2)} </pre> */}
        </Stack>
    );
}
